import { hydrateRoot } from 'react-dom/client';
import { StartClient } from '@tanstack/react-start/client';
import { initSentryClient } from './sentry.client.config';

initSentryClient();

hydrateRoot(document, <StartClient />);
